import withDefaultPrevented from '../../../../withDefaultPrevented';
import Conditional from '../../../Conditional';
import { connectLocation } from '../../../location/LocationConnectors';

const AppliedFilterView = ({ filter, onToggleFilter, title }) => {
  const onRemoveFilterClick = withDefaultPrevented(() => onToggleFilter(filter));
  // const { analytics, label } = filtersConfig[filterKey]; TODO analytics

  return (
    <button
      className="applied-filter"
      tabIndex="0"
      onClick={onRemoveFilterClick}
      data-track="remove-filter"
      // data-track-filter-name={analytics.name}
      // data-track-filter-option={analytics.option(value)}
    >
      <span>{title}</span>

      <span className="close" aria-hidden="true">
        &times;
      </span>
    </button>
  );
};

// t from connectLocation
const AppliedFiltersList = ({ filters, onToggleFilter, reset, t }) =>
  filters.length > 0 && (
    <div className="applied-filters-container">
      <span className="label">{t('product_list.applied_filters')}</span>
      {filters.map(value => (
        <AppliedFilterView
          key={JSON.stringify(value)}
          filter={value}
          title={value.title}
          onToggleFilter={onToggleFilter}
        />
      ))}

      <Conditional if={filters.length}>
        <button className="oc-icon reset-filter" onClick={() => reset()} data-track="reset">
          <i className="icon reset" aria-hidden="true" />
          {t('product_list.reset_filters')}
        </button>
      </Conditional>
    </div>
  );

export default connectLocation(AppliedFiltersList);
